<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="view-container">
    <div class="flex items-center justify-start gap-6">
      <a
        mat-button
        mat-stroked-button
        color="secondary"
        class="revolution"
        [href]="clientData.baseUrl"
        *ngIf="clientData.baseUrl"
      >
        {{ 'back' | sharedTranslate }}
      </a>
    </div>
    <div class="flex justify-center h-fit mt-2">
      <mat-card
        class="flex flex-row gap-6 items-center  py-7 px-10 mb-5 border border-at-ef-revolution-supergrey-500 rounded-lg mat-elevation-z0"
      >
        <div>
          <mat-icon
            class="card-flex-rounded-icon"
            svgIcon="error_outline"
          ></mat-icon>
        </div>
        <div class="w-auto">
          <!-- prettier-ignore -->
          <p
            class="m-0 justify-self-start items-center text-mat-ef-revolution-primary-500"
            [innerHTML]="getTranslation()"
          ></p>
        </div>
      </mat-card>
    </div>
  </div>
</div>
